import React from 'react';

import Utils from 'files/Utils.js';

const STATS = [
    { value: '1.38M', label: 'Fires Responded to in 2025' },
    { value: '3,920', label: 'Civilian Fire Deaths in 2025' },
    { value: '$19B', label: 'In Property Damage from Fires' },
    { value: 'Every 3 Hrs', label: 'A Home Fire Death Occurs' }
];

const Stats = () => {

    const isMobile = Utils.isMobile();

    return (
        <section style={{
            backgroundColor: '#000000',
            padding: '40px 0',
            width: '100%'
        }}>
            <div style={{
                margin: '0 auto',
                maxWidth: 1280,
                padding: '0 16px',
                width: '100%'
            }}>
                <div style={{
                    display: 'grid',
                    gap: 32,
                    gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : 'repeat(4, 1fr)'
                }}>
                    {STATS.map((stat, index) => (
                        <div
                        key={index}
                        style={{ textAlign: 'center' }}>
                            <p style={{
                                color: '#FFFFFF',
                                fontFamily: '"Poppins", sans-serif',
                                fontSize: isMobile ? 32 : 48,
                                fontWeight: 700,
                                margin: '0 0 8px 0'
                            }}>{stat.value}</p>
                            <p style={{
                                color: 'rgba(255,255,255,0.7)',
                                fontFamily: '"Lato", sans-serif',
                                fontSize: isMobile ? 14 : 16,
                                margin: 0
                            }}>{stat.label}</p>
                        </div>
                    ))}
                </div>
                <div style={{
                    marginTop: 32,
                    textAlign: 'center'
                }}>
                    <p style={{
                        color: 'rgba(255,255,255,0.5)',
                        fontFamily: '"Lato", sans-serif',
                        fontSize: 12,
                        margin: 0
                    }}>{'Source: NFPA | Report: "Fire Loss in the United States"'}</p>
                </div>
            </div>
        </section>
    )
}

export default Stats;
